// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Y6lL","selected":"Chip_selected__1Ru4m"};